import axios from "axios";
import { API_URL } from "../../constants/config";

export const downloadPdf = (learner_id) => {
  axios
    .post(`${API_URL}api/v1/pdf_lambda`, {
      user_id: learner_id,
    })
    .then((response) => {
      console.log(response.data.message);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const downloadZip = (learner_id) => {
  axios
    .post(`${API_URL}api/v1/zip_lambda`, {
      user_id: learner_id,
    })
    .then((response) => {
      console.log(response.data.message);
    })
    .catch((err) => {
      console.log(err);
    });
};
